import { render, staticRenderFns } from "./SeletorCliente.vue?vue&type=template&id=8802c8ee&scoped=true"
import script from "./SeletorCliente.vue?vue&type=script&lang=js"
export * from "./SeletorCliente.vue?vue&type=script&lang=js"
import style0 from "./SeletorCliente.vue?vue&type=style&index=0&id=8802c8ee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8802c8ee",
  null
  
)

export default component.exports